import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffAddEditIntegrationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffAddEditIntegrationModalContainer" */
      './StaffAddEditIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
